import {Headers, RequestOptions} from "@angular/http";
/**
 * Created by kennethmwangi on 21/04/2017.
 */

export class BaseService {

  api_key = "8E692A68461AD4A52774D1648BC17";

  public createHeaders(type, credentials = {username:'', password: ''}):RequestOptions {

    if (type === "Authorization") {
       let headers = new Headers();
       headers.append("Authorization", this.api_key);
       headers.append("Content-type", "application/json");
       let options = new RequestOptions({ headers: headers });
      return options;

    }

    if (type === "Credentials") {
      let headers = new Headers();
      headers.append("Authorization", "Basic " + btoa(credentials.username + ":" + credentials.password));
      headers.append("Content-type", "application/json");
      let options = new RequestOptions({ headers: headers });
      return options;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/base-service.ts